import { createMuiTheme } from '@material-ui/core';

export const LightMuiTheme = createMuiTheme({
  typography: {
    fontFamily: `'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen',
      'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue', sans-serif;`,
    h1: {
      fontSize: '2.25rem',
      fontWeight: 700,
    },
    h2: {
      fontSize: '2rem',
      fontWeight: 700,
    },
    h3: {
      fontSize: '1.825rem',
      fontWeight: 500,
    },
    h4: {
      fontSize: '1.425rem',
      fontWeight: 500,
    },
    h5: {
      fontSize: '1.25rem',
      fontWeight: 500,
    },
    h6: {
      fontSize: '1.125rem',
      fontWeight: 500,
    },
  },
  palette: {
    primary: {
      main: 'hsl(280, 80%, 50%)',
      contrastText: '#FFF',
    },
  },
  overrides: {
    MuiButton: {
      root: {
        padding: '12px 16px',
        fontSize: '1rem',
        lineHeight: 1.25,
      },
      label: {
        textTransform: 'none',
      },
    },
  },
  props: {
    MuiButton: {
      disableElevation: true,
    },
  },
  shape: {
    borderRadius: 8,
  },
  shadows: [
    'none',
    '0px 2px 1px -1px rgba(0,0,0,0.2),0px 1px 1px 0px rgba(0,0,0,0.20),0px 1px 3px 0px rgba(0,0,0,0.20)',
    '0px 3px 1px -2px rgba(0,0,0,0.2),0px 2px 2px 0px rgba(0,0,0,0.20),0px 1px 5px 0px rgba(0,0,0,0.20)',
    '0px 3px 3px -2px rgba(0,0,0,0.2),0px 3px 4px 0px rgba(0,0,0,0.20),0px 1px 8px 0px rgba(0,0,0,0.20)',
    '0px 2px 4px -1px rgba(0,0,0,0.2),0px 4px 5px 0px rgba(0,0,0,0.20),0px 1px 10px 0px rgba(0,0,0,0.20)',
    '0px 3px 5px -1px rgba(0,0,0,0.2),0px 5px 8px 0px rgba(0,0,0,0.20),0px 1px 14px 0px rgba(0,0,0,0.20)',
    '0px 3px 5px -1px rgba(0,0,0,0.2),0px 6px 10px 0px rgba(0,0,0,0.20),0px 1px 18px 0px rgba(0,0,0,0.20)',
    '0px 4px 5px -2px rgba(0,0,0,0.2),0px 7px 10px 1px rgba(0,0,0,0.20),0px 2px 16px 1px rgba(0,0,0,0.20)',
    '0px 5px 5px -3px rgba(0,0,0,0.2),0px 8px 10px 1px rgba(0,0,0,0.20),0px 3px 14px 2px rgba(0,0,0,0.20)',
    '0px 5px 6px -3px rgba(0,0,0,0.2),0px 9px 12px 1px rgba(0,0,0,0.20),0px 3px 16px 2px rgba(0,0,0,0.20)',
    '0px 6px 6px -3px rgba(0,0,0,0.2),0px 10px 14px 1px rgba(0,0,0,0.20),0px 4px 18px 3px rgba(0,0,0,0.20)',
    '0px 6px 7px -4px rgba(0,0,0,0.2),0px 11px 15px 1px rgba(0,0,0,0.20),0px 4px 20px 3px rgba(0,0,0,0.20)',
    '0px 7px 8px -4px rgba(0,0,0,0.2),0px 12px 17px 2px rgba(0,0,0,0.20),0px 5px 22px 4px rgba(0,0,0,0.20)',
    '0px 7px 8px -4px rgba(0,0,0,0.2),0px 13px 19px 2px rgba(0,0,0,0.20),0px 5px 24px 4px rgba(0,0,0,0.20)',
    '0px 7px 9px -4px rgba(0,0,0,0.2),0px 14px 21px 2px rgba(0,0,0,0.20),0px 5px 26px 4px rgba(0,0,0,0.20)',
    '0px 8px 9px -5px rgba(0,0,0,0.2),0px 15px 22px 2px rgba(0,0,0,0.20),0px 6px 28px 5px rgba(0,0,0,0.20)',
    '0px 8px 10px -5px rgba(0,0,0,0.2),0px 16px 24px 2px rgba(0,0,0,0.20),0px 6px 30px 5px rgba(0,0,0,0.20)',
    '0px 8px 11px -5px rgba(0,0,0,0.2),0px 17px 26px 2px rgba(0,0,0,0.20),0px 6px 32px 5px rgba(0,0,0,0.20)',
    '0px 9px 11px -5px rgba(0,0,0,0.2),0px 18px 28px 2px rgba(0,0,0,0.20),0px 7px 34px 6px rgba(0,0,0,0.20)',
    '0px 9px 12px -6px rgba(0,0,0,0.2),0px 19px 29px 2px rgba(0,0,0,0.20),0px 7px 36px 6px rgba(0,0,0,0.20)',
    '0px 10px 13px -6px rgba(0,0,0,0.2),0px 20px 31px 3px rgba(0,0,0,0.20),0px 8px 38px 7px rgba(0,0,0,0.20)',
    '0px 10px 13px -6px rgba(0,0,0,0.2),0px 21px 33px 3px rgba(0,0,0,0.20),0px 8px 40px 7px rgba(0,0,0,0.20)',
    '0px 10px 14px -6px rgba(0,0,0,0.2),0px 22px 35px 3px rgba(0,0,0,0.20),0px 8px 42px 7px rgba(0,0,0,0.20)',
    '0px 11px 14px -7px rgba(0,0,0,0.2),0px 23px 36px 3px rgba(0,0,0,0.20),0px 9px 44px 8px rgba(0,0,0,0.20)',
    '0px 11px 15px -7px rgba(0,0,0,0.2),0px 24px 38px 3px rgba(0,0,0,0.20),0px 9px 46px 8px rgba(0,0,0,0.20)',
  ],
});

export const DarkMuiTheme = createMuiTheme({
  ...LightMuiTheme,
  palette: {
    type: 'dark',
    primary: {
      main: 'hsl(280, 80%, 70%)',
      contrastText: 'white',
    },
  },
  overrides: {
    ...LightMuiTheme.overrides,
    MuiPaper: {
      root: {
        position: 'relative',
        '&::after': {
          position: 'absolute',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          content: "''",
          pointerEvents: 'none',
          boxShadow: '0px 0px 0px 1px hsl(0, 0%, 40%)',
          borderRadius: 'inherit',
        },
      },
    },
  },
});

export const ColoredMuiTheme = createMuiTheme({
  ...LightMuiTheme,
  palette: {
    background: {
      default: 'hsl(280, 80%, 50%)',
      paper: 'hsl(280, 80%, 50%)',
    },
    primary: {
      main: '#FFF',
      contrastText: 'hsl(280, 80%, 50%)',
    },
    text: {
      primary: '#FFF',
      secondary: 'rgba(255, 255, 255, 0.6)',
    },
  },
});
